<template>
  <el-select-tree
    v-model="selectValue"
    v-bind="$attrs"
    :options="options"
    :default-props="normalizer"
    :is-leaf="true"
    filterable
    v-on="$listeners"
  />
</template>

<script>
import { choseRoleTreeData } from '@/api/common'
export default {
  name: 'UmBusRole',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    roleType: {
      type: Array,
      default: () => [1003501, 1003502] // 角色组 角色
    },
    roleNature: {
      type: Array,
      default: () => [1003511, 1003512, 1003513] // 角色组 角色 '1003511': '内部','1003512': '承建商','1003513': '不限'
    },
    value: {
      type: [Array, Number, String],
      default: null
    }
  },
  data() {
    return {
      // define the default value
      selectValue: null,
      // define options
      options: [],
      normalizer: {
        value: 'busRoleId',
        label: 'roleName',
        children: 'children',
        selectlabel: 'roleFullName'
      }
    }
  },
  watch: {
    selectValue(val) {
      this.$emit('change', val)
    },
    value(val) {
      if (JSON.stringify(val) !== JSON.stringify(this.selectValue)) {
        this.selectValue = this.value
      }
    }
  },
  created() {
    this.getTree()
  },
  mounted() {
    this.selectValue = this.value
  },
  methods: {
    init(list) {
      list.forEach(item => {
        if (item.children) {
          this.init(item.children)
        }
        if (item.children.length == 0 && item.roleType == 1003501) {
          item.isDisabled = true
        }
      })
    },
    deleteEmpty(list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].children) {
          if (list[i].children.length === 0) {
            delete list[i].children
          } else {
            this.deleteEmpty(list[i].children)
          }
        }
      }
    },
    limitText(count) {
      return `还有 ${count} 个`
    },
    getTree() {
      choseRoleTreeData({
        filterRoleType: this.roleType,
        filterRoleNature: this.roleNature
      }).then(d => {
        console.log(d)
        const list = d.data
        this.init(list)
        this.deleteEmpty(list)
        this.options = list
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
